export default __webpack_public_path__ + "static/media/left.f70e8bc7.png";